import Actions from '../../odata/actions';

const actions = new Actions('interviewQuestion', 'interviewQuestions');

export default actions;
